import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreatePortTariffComponent } from './create-port-tariff.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';



@NgModule({
  declarations: [
    CreatePortTariffComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    DragDropModule
  ],
  exports:[
    CreatePortTariffComponent
  ]
})
export class CreatePortTariffModule { }
